import { AxiosError, AxiosResponse } from 'axios';

// We check error.response because an Axios Response can exist but the response can be undefined (ie. user is offline)
export const isAxiosErrorWithResponse = (error: any): error is AxiosError & { response: AxiosResponse } => {
    return Boolean(error && error.config && error.response);
};
